export default __webpack_public_path__ + "static/media/background.858d6490.jpg";